import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes, AppVersion, ENV_CONFIG, EnvConfig } from '@core';
import { SzButtonComponent } from '@ui';
import { UpdateService, VersionConfigSyncService } from '@update/infra';
import { getNewVersionNative } from '../application/utils';

@Component({
  selector: 'lib-blocked-version',
  templateUrl: './blocked-version.page.html',
  styleUrls: ['./blocked-version.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzButtonComponent, TranslateModule]
})
export class BlockedVersionPage {
  private readonly env: EnvConfig = inject(ENV_CONFIG);
  private readonly router: Router = inject(Router);
  private readonly updateService: UpdateService = inject(UpdateService);
  private readonly versionConfigSyncService: VersionConfigSyncService = inject(VersionConfigSyncService);

  readonly newestVersion: Signal<string | undefined> = toSignal(this.updateService.newestVersion());
  readonly appVersion: string = AppVersion;

  async goToApp(): Promise<void> {
    await this.versionConfigSyncService.sync();
    await new Promise((resolve: (value: void) => void) => setTimeout(resolve, 500));
    void this.router.navigate([`/${AppRoutes.ROOT}`]);
  }

  getApk(): void {
    getNewVersionNative(this.env);
  }
}
